/** The file contract shared by client evidence and firm deliveries. */
export const portalMaxFileBytes = 25 * 1024 * 1024

export const portalFileFormats = [
  { extension: "pdf", extensions: ["pdf"], mimeType: "application/pdf", processing: "document" },
  { extension: "jpg", extensions: ["jpg", "jpeg"], mimeType: "image/jpeg", processing: "document" },
  { extension: "png", extensions: ["png"], mimeType: "image/png", processing: "document" },
  { extension: "heic", extensions: ["heic"], mimeType: "image/heic", processing: "document" },
  { extension: "heif", extensions: ["heif"], mimeType: "image/heif", processing: "document" },
  { extension: "csv", extensions: ["csv"], mimeType: "text/csv", processing: "stored" },
  { extension: "xlsx", extensions: ["xlsx"], mimeType: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", processing: "stored" },
  { extension: "docx", extensions: ["docx"], mimeType: "application/vnd.openxmlformats-officedocument.wordprocessingml.document", processing: "stored" },
  { extension: "txt", extensions: ["txt"], mimeType: "text/plain", processing: "stored" },
  { extension: "ofx", extensions: ["ofx"], mimeType: "application/x-ofx", processing: "stored" },
  { extension: "qfx", extensions: ["qfx"], mimeType: "application/x-qfx", processing: "stored" },
  { extension: "qif", extensions: ["qif"], mimeType: "application/x-qif", processing: "stored" },
  { extension: "qbo", extensions: ["qbo"], mimeType: "application/x-qbo", processing: "stored" },
] as const

export type PortalFileFormat = (typeof portalFileFormats)[number]
export type PortalFileProcessing = PortalFileFormat["processing"]

export const portalAcceptedMimeTypes: readonly [
  PortalFileFormat["mimeType"],
  ...PortalFileFormat["mimeType"][],
] = [
  portalFileFormats[0].mimeType,
  ...portalFileFormats.slice(1).map((format) => format.mimeType),
]

export function portalFileFormatForName(fileName: string): PortalFileFormat | null {
  const extension = /\.([a-z0-9]+)$/i.exec(fileName)?.[1]?.toLowerCase()
  return portalFileFormats.find((format) =>
    format.extensions.some((value) => value === extension)
  ) ?? null
}

export function portalFileFormatForMimeType(mimeType: string): PortalFileFormat | null {
  return portalFileFormats.find((format) => format.mimeType === mimeType.toLowerCase()) ?? null
}
